var _a, _b, _c;
import { UrlMappingsKeys } from '../url-mappings-keys';
import { mainMappingVariable } from '../../main-mapping-pattern';
export var forumMapping = (_a = {},
    _a[UrlMappingsKeys.FORUM_POST] = {
        variables: ['categorySlug', 'postSlug'],
        required: ['categorySlug', 'postSlug'],
        subMappings: (_b = {},
            _b[UrlMappingsKeys.FORUM_POST_EDIT] = {
                defaultMapping: "".concat(mainMappingVariable, "/edit"),
            },
            _b[UrlMappingsKeys.FORUM_POST_PAGINATION] = {
                required: ['page'],
                defaultMapping: "".concat(mainMappingVariable, "/p-{{page}}"),
            },
            _b[UrlMappingsKeys.FORUM_POST_DEEP_LINK_DATA] = {
                required: ['deepLinkData'],
                defaultMapping: "".concat(mainMappingVariable, "/dl-{{deepLinkData}}"),
            },
            _b[UrlMappingsKeys.FORUM_POST_PAGINATION_AND_DEEP_LINK_DATA] = {
                required: ['page', 'deepLinkData'],
                defaultMapping: "".concat(mainMappingVariable, "/p-{{page}}/dl-{{deepLinkData}}"),
            },
            _b),
    },
    _a[UrlMappingsKeys.FORUM_CATEGORY] = {
        variables: ['slug'],
        required: ['slug'],
        subMappings: (_c = {},
            _c[UrlMappingsKeys.FORUM_CATEGORY_CREATE_POST] = {
                defaultMapping: "".concat(mainMappingVariable, "/create-post"),
            },
            _c[UrlMappingsKeys.FORUM_CATEGORY_CREATE_QUESTION] = {
                defaultMapping: "".concat(mainMappingVariable, "/create-question"),
            },
            _c[UrlMappingsKeys.FORUM_CATEGORY_PAGINATION] = {
                required: ['page'],
                defaultMapping: "".concat(mainMappingVariable, "/p-{{page}}"),
            },
            _c),
    },
    _a);
//# sourceMappingURL=forum.js.map